import React, { useState, useEffect } from "react";
import LoadingIndicator from '../shared/LoadingIndicator';
import { Collapse, Button, Tooltip, Position, NonIdealState, Classes } from "@blueprintjs/core";
import Flexbox from "flexbox-react";
import classNames from "classnames";
import _ from "lodash";
import axios from "axios";
import Cookies from "js-cookie";
import ProfileElementV2 from "./ProfileElementV2";

const ProfileDataV2 = ({ userId, profileTemplateId }) => {
  const [profileSections, setProfileSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [collapsedSections, setCollapsedSections] = useState({}); // track collapsed state per section

  useEffect(() => {
    if (!profileTemplateId || !userId) return;

    setLoading(true);
    setError(null);

    axios
      .get(`${Cookies.get("apiEnv")}/fetch_profile_data/employee_profile_data?user_id=${userId}&profile_template_id=${profileTemplateId}`)
      .then(res => {
        const data = res.data.user_data || [];
        setProfileSections(data);

        // initialize collapsed state for each section
        const initialCollapsed = {};
        data.forEach(section => {
          initialCollapsed[section.section_id] = false;
        });
        setCollapsedSections(initialCollapsed);
      })
      .catch(err => {
        console.error("Error fetching profile data:", err);
        setError("Failed to fetch profile data.");
        setProfileSections([]);
      })
      .finally(() => setLoading(false));
  }, [userId, profileTemplateId]);

  if (!profileTemplateId || profileSections.length === 0) {
    return (
      <Flexbox flexGrow={1} flexDirection="column" marginTop="20px" className="bp3-card">
        <NonIdealState
          title={I18n.t("js.nothing_to_show")}
          description={I18n.t("js.there_are_no_sections_to_show")}
          icon="duplicate"
          className="bp3-text-muted"
        />
      </Flexbox>
    );
  }

  if (loading) {
    return (
      <Flexbox justifyContent="center" alignItems="center" height="200px">
        <LoadingIndicator />
      </Flexbox>
    );
  }

  if (error) {
    return <p>{error}</p>;
  }

  const cardClass = classNames("bp3-card bp3-card-no-padding");
  const sectionClass = classNames("template-section-header");
  let textClass = classNames("bp3-text-muted push-10-r");
  return (
    <Flexbox flexGrow={1} flexDirection="column">
      {profileSections.map(section => {
        const hasData = _.some(section.elements, el => el.value);
        const isCollapsed = collapsedSections[section.section_id];

        if (!hasData) {
          return (
            <Flexbox flexDirection="column" className="template-area" marginTop="20px" marginBottom="20px">
            <NonIdealState
              title={I18n.t('js.nothing_to_show')}
              description={I18n.t('js.there_are_no_elements_in_this_section')}
              icon="multi-select"
              className="bp3-text-muted"
            />
          </Flexbox>
          );
        }

        return (
          <Flexbox key={section.section_id} className={cardClass} flexDirection="column" marginTop="20px" width="100%">
            {/* Section header */}
            <Flexbox
              flexGrow={1}
              className={sectionClass}
              paddingLeft="30px"
              paddingRight="30px"
              paddingTop="10px"
              paddingBottom="10px"
              maxHeight="50px"
            >
              <Flexbox flexGrow={1} paddingTop="10px">
                <h4 className={`${Classes.HEADING} push-10-r`}>{section.section_name}</h4>
              </Flexbox>
              <Flexbox flexGrow={0} flexDirection="row" alignItems="center" justifyContent="center">
                <small className={textClass}>
                  {I18n.t("js.item_section_x_of_y", {
                    x: profileSections.indexOf(section) + 1,
                    y: profileSections.length
                  })}
                </small>
                <Flexbox flexDirection="row" justifyContent="center">
                  <Tooltip content={isCollapsed ? "Expand" : "Collapse"} portalContainer={document.body} position={Position.TOP}>
                    <Button
                      icon={isCollapsed ? "expand-all" : "collapse-all"}
                      minimal={true}
                      onClick={() =>
                        setCollapsedSections(prev => ({
                          ...prev,
                          [section.section_id]: !prev[section.section_id]
                        }))
                      }
                    />
                  </Tooltip>
                </Flexbox>
              </Flexbox>
            </Flexbox>

            {/* Section body */}
            <Flexbox flexDirection="column" flexGrow={1} className="user-profile-section"
             
            >
              <Collapse isOpen={!isCollapsed} keepChildrenMounted={true}>
              <Flexbox flexDirection="column" flexGrow={1}>
                {_.map(section.elements, element => (
                  <ProfileElementV2 key={element.id} element={element}></ProfileElementV2>
                ))}
                </Flexbox>
              </Collapse>
            </Flexbox>
          </Flexbox>
        );
      })}
    </Flexbox>
  );
};

export default ProfileDataV2;

// import React, { useState, useEffect } from "react";
// import { Collapse, Button, Tooltip, Position, Spinner } from "@blueprintjs/core";
// import Flexbox from "flexbox-react";
// import classNames from "classnames";
// import _ from "lodash";
// import axios from "axios";
// import Cookies from "js-cookie";

// import ProfileElementV2 from './UserProfileTemplateV2';

// const ProfileDataV2 = ({ userId, profileTemplateId }) => {
//   const [profileSections, setProfileSections] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [collapsedSections, setCollapsedSections] = useState({}); // track collapsed state per section

//   useEffect(() => {
//     if (!profileTemplateId || !userId) return;

//     setLoading(true);
//     setError(null);

//     axios
//       .get(
//         `${Cookies.get("apiEnv")}/fetch_profile_data/employee_profile_data?user_id=${userId}&profile_template_id=${profileTemplateId}`
//       )
//       .then((res) => {
//         const data = res.data.user_data || [];
//         setProfileSections(data);

//         // initialize collapsed state for each section
//         const initialCollapsed = {};
//         data.forEach((section) => {
//           initialCollapsed[section.id] = false;
//         });
//         setCollapsedSections(initialCollapsed);
//       })
//       .catch((err) => {
//         console.error("Error fetching profile data:", err);
//         setError("Failed to fetch profile data.");
//         setProfileSections([]);
//       })
//       .finally(() => setLoading(false));
//   }, [userId, profileTemplateId]);

//   if (!profileTemplateId) {
//     return <p>Please select a template to view profile data.</p>;
//   }

//   if (loading) {
//     return (
//       <Flexbox justifyContent="center" alignItems="center" height="200px">
//         <LoadingIndicator />
//       </Flexbox>
//     );
//   }

//   if (error) {
//     return <p>{error}</p>;
//   }

//   if (profileSections.length === 0) {
//     return <p>No profile data found for this template.</p>;
//   }

//   const cardClass = classNames("bp3-card bp3-card-no-padding");
//   const sectionClass = classNames("template-section-header");
//    console.log("profile",)
//   return (
//     <div className="profile-data-container">
//       {profileSections.map((section) => {
//         const hasData = _.some(section.elements, (el) => el.value);
//         const isCollapsed = collapsedSections[section.id];

//         if (!hasData) {
//           return (
//             <Flexbox
//               key={section.id}
//               flexDirection="column"
//               className="template-area"
//               marginTop="20px"
//               marginBottom="20px"
//             >
//               <div className="bp3-text-muted">No data in this section</div>
//             </Flexbox>
//           );
//         }

//         return (
//           <Flexbox
//             key={section.id}
//             className={cardClass}
//             flexDirection="column"
//             marginTop="20px"
//           >
//             <Flexbox
//               flexGrow={1}
//               className={sectionClass}
//               paddingLeft="30px"
//               paddingRight="30px"
//               paddingTop="10px"
//               paddingBottom="10px"
//               maxHeight="50px"
//             >
//               <Flexbox flexGrow={1} paddingTop="10px">
//                 <h4>{section.title}</h4>
//               </Flexbox>
//               <Flexbox
//                 flexGrow={0}
//                 flexDirection="row"
//                 alignItems="center"
//                 justifyContent="center"
//               >
//                 <Tooltip
//                   content={isCollapsed ? "Expand" : "Collapse"}
//                   portalContainer={document.body}
//                   position={Position.TOP}
//                 >
//                   <Button
//                     icon={isCollapsed ? "expand-all" : "collapse-all"}
//                     minimal={true}
//                     onClick={() =>
//                       setCollapsedSections((prev) => ({
//                         ...prev,
//                         [section.id]: !prev[section.id],
//                       }))
//                     }
//                   />
//                 </Tooltip>
//               </Flexbox>
//             </Flexbox>

//             <Flexbox
//               flexDirection="column"
//               flexGrow={1}
//               className="user-profile-section"
//             >
//               <Collapse isOpen={!isCollapsed} keepChildrenMounted={true}>
//                 {_.map(section.elements, (element) => (
//                   <ProfileElementV2 key={element.id} element={element} />
//                 ))}
//               </Collapse>
//             </Flexbox>
//           </Flexbox>
//         );
//       })}
//     </div>
//   );
// };

// export default ProfileDataV2;

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import Cookies from "js-cookie";

// // Child component to fetch and display user data of a selected template
// const ProfileDataV2 = ({ userId, profileTemplateId }) => {
//   const [profileData, setProfileData] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     if (!profileTemplateId) return;

//     setLoading(true);
//     axios
//       .get(
//         `${Cookies.get("apiEnv")}/fetch_profile_data/employee_profile_data?user_id=${userId}&profile_template_id=${profileTemplateId}`
//       )
//       .then((res) => {
//         setProfileData(res.data.user_data || []);
//       })
//       .catch(() => {
//         setProfileData([]);
//       })
//       .finally(() => setLoading(false));
//   }, [userId, profileTemplateId]);

//   if (!profileTemplateId) {
//     return <p>Please select a template to view profile data.</p>;
//   }

//   if (loading) {
//     return <p>Loading profile data...</p>;
//   }

//   if (profileData.length === 0) {
//     return <p>No profile data found for this template.</p>;
//   }

//   return (
//     <div className="profile-data-container">
//       <h3>Profile Data</h3>
//       <ul>
//         {profileData.map((field) => (
//           <li key={field.id}>
//             <strong>{field.name}:</strong>{" "}
//             {field.value ? field.value.toString() : "N/A"}
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default ProfileDataV2;

// import React, { useState } from "react";
// import { Collapse, Button, Tooltip, Position } from "@blueprintjs/core";
// import Flexbox from "flexbox-react";
// import classNames from "classnames";
// import _ from "lodash";

// const ProfileDataV2 = ({ section }) => {
//   const [isCollapsed, setIsCollapsed] = useState(false);

//   const hasData = _.some(section.elements, (el) => el.value);

//   if (!hasData) {
//     return (
//       <Flexbox
//         flexDirection="column"
//         className="template-area"
//         marginTop="20px"
//         marginBottom="20px"
//       >
//         <div className="bp3-text-muted">No data in this section</div>
//       </Flexbox>
//     );
//   }

//   const cardClass = classNames("bp3-card bp3-card-no-padding");
//   const sectionClass = classNames("template-section-header");

//   return (
//     <Flexbox
//       key={section.id}
//       className={cardClass}
//       flexDirection="column"
//       marginTop="20px"
//     >
//       <Flexbox
//         flexGrow={1}
//         className={sectionClass}
//         paddingLeft="30px"
//         paddingRight="30px"
//         paddingTop="10px"
//         paddingBottom="10px"
//         maxHeight="50px"
//       >
//         <Flexbox flexGrow={1} paddingTop="10px">
//           <h4>{section.title}</h4>
//         </Flexbox>
//         <Flexbox flexGrow={0} flexDirection="row" alignItems="center" justifyContent="center">
//           <Tooltip
//             content={isCollapsed ? "Expand" : "Collapse"}
//             portalContainer={document.body}
//             position={Position.TOP}
//           >
//             <Button
//               icon={isCollapsed ? "expand-all" : "collapse-all"}
//               minimal={true}
//               onClick={() => setIsCollapsed(!isCollapsed)}
//             />
//           </Tooltip>
//         </Flexbox>
//       </Flexbox>
//       <Flexbox flexDirection="column" flexGrow={1} className="user-profile-section">
//         <Collapse isOpen={!isCollapsed} keepChildrenMounted={true}>
//           {_.map(section.elements, (element) => (
//             <ProfileElement key={element.id} element={element} />
//           ))}
//         </Collapse>
//       </Flexbox>
//     </Flexbox>
//   );
// };

// export default ProfileDataV2;
